<template>
  <section class="chatbox">
    <div class="chat-header-container">
      <div class="header-icon-and-title">
        <ion-icon class="chat-icon" name="chatbubbles-outline" v-if="!chat.header.startsWith('<')"></ion-icon>
        <div class="chat-title" v-html="chat.header"></div>
      </div>
      <div class="chatbox-pinned-chat-message-container" v-if="showPinnedChatMessages && pinnedChatMessages.length">
        <div class="pinned-chat-message" :style="{background:pinnedMessage.tags && pinnedMessage.tags.startsWith('#') ? pinnedMessage.tags : 'var(--chat-pinnedBGColor)'}" v-for="(pinnedMessage,p) in pinnedChatMessages" :key="p">
          <span class="pinned-chat-message-delete" v-if="isAdmin"><i title="Remover" class="fas fa-times-circle" @click.prevent="unpinChatMessage(pinnedMessage)"></i></span>
          <img :src="pinnedMessage.image" @load="handleLoadingImages" v-if="pinnedMessage.image && $store.state.template.header.loginVisible">
          <div class="pinned-chat-message-texts">
            <div class="pinned-chat-message-user-name">{{pinnedMessage.name}}</div>
            <div class="pinned-chat-message-text" v-html="parsePinnedMsg(pinnedMessage.message)"></div>
          </div>
          <button class="pinned-chat-message-btn" v-if="usesLinkButton(pinnedMessage)" @click.prevent="openPinnedLink(pinnedMessage.link)"><i class="fas fa-info"></i></button>
        </div>
      </div>
    </div>

    <div class="chat-messages-container" ref="messagesContainer" @scroll="scrollHandler">
      <div class="chat-message" :style="{ opacity: (msg.visible)  ? '1' : '0.8', filter: `saturate(${(msg.visible) ? '1' : '0'})` }" v-show="isAdmin || msg.visible || msg.alert" v-for="(msg,k) in messages" :key="k">
        <span class="chat-message-pinner" v-if="(isAdmin || isUser(msg.user_id,msg.userId)) && !msg.message.includes('[Em moderação]')">
          <!-- MESSAGE ACTIONS -->
          <span v-if="isAdmin && enableReply"><i title="Responder" class="fas fa-reply" @click.prevent="replyChatMessage(msg)"></i></span>
          <span v-if="isAdmin"><i title="Tornar Visível" class="fas fa-eye" @click.prevent="visibleChatMessage(msg, true)" v-if="!msg.visible"></i></span>
          <span v-if="isAdmin"><i title="Tornar Invisível" class="fas fa-eye-slash" @click.prevent="visibleChatMessage(msg, false)" v-if="msg.visible"></i></span>
          <span v-if="isAdmin"><i title="Destacar aqui" class="fas fa-bahai" @click.prevent="highlightChatMessage(msg, true)" v-if="msg.visible && !msg.highlight"></i></span>
          <span v-if="isAdmin"><i title="Retirar destaque" class="fas fa-virus-slash" @click.prevent="highlightChatMessage(msg, false)" v-if="msg.visible && msg.highlight"></i></span>
          <span v-if="isAdmin"><i title="Fixar no topo" class="fas fa-thumbtack" @click.prevent="pinChatMessage(msg, true)" v-if="msg.visible"></i></span>
          <span><i title="Remover" class="fas fa-trash-alt" @click.prevent="deleteChatMessage(msg)"></i></span>
        </span>
        <!-- CONTENT -->
        <div class="chat-message-content" :class="{'isHighlighted':msg.highlight}">
          <div class="avatar-and-name-container">
            <img class="chat-user-avatar" :src="msg.image" v-if="enableAvatar && msg.image" />
            <span class="chat-user-name" :class="{'chat-user-name-isAdmin':msg.tags && msg.tags.isAdmin}">{{ msg.name }}</span>
            <span class="msg-message" :class="{'with-line-brake':enableLineBreak}" v-if="!(msg.tags && (msg.tags.giphy || msg.tags.reply))" v-html="parseMsg(msg)"></span>
          </div>
          <!-- REPLY -->
          <div class="reply-container" v-if="msg.tags && msg.tags.reply">
            <span class="reply-user-name"><i class="fas fa-reply"></i> {{msg.tags.reply.name}}</span>
            <!-- REPLY TAGS GIPHY img -->
            <img class="giphy-img" :src="msg.tags.reply.tags.giphy" @load="handleLoadingImages" v-if="msg.tags.reply.tags && msg.tags.reply.tags.giphy">
            <!-- REPLY TAGS REPLY message-->
            <span class="reply-text" :class="{'with-line-brake':enableLineBreak}"> {{ msg.tags.reply.message }}</span>
          </div>
          <!-- GIPHY -->
          <div class="message-giphy-container" v-if="msg.tags && msg.tags.giphy">
            <img class="giphy-img" :src="msg.tags.giphy" @load="handleLoadingImages">
          </div>
          <!-- MESSAGE WITH REPLY OR GIPHY -->
          <div class="message-text-container" v-if="(msg.tags && (msg.tags.giphy || msg.tags.reply))">
            <span class="msg-message" :class="{'with-line-brake':enableLineBreak}" v-html="parseMsg(msg)"></span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- SCROLL TO LATEST BTN -->
    <button class="scrollToTopBtn" ref="scrollToTopBtn" v-show="!readyToScroll "><ion-icon class="scrollBtn-icon" name="chevron-down-circle-sharp" v-show="!pickedGiphy && !(reply && reply.message)"></ion-icon></button>
    <div class="toggle-autoscroll-btn" v-if="isAdmin">
      <label for="autoScrollInput" style="cursor:pointer">Auto scroll</label>
      <!-- <i class="fas fa-sort-amount-down"></i> -->
      <input id="autoScrollInput" type="checkbox" v-model="enableAutoScroll">
    </div>

    <GiphyPicker ref="giphyPicker" @picked="gifPicked" @close="showGiphyPicker=false" v-show="showGiphyPicker" />
    <!-- PICKED GIPHY -->
    <div class="picked-giphy-container" v-show="pickedGiphy">
      <img class="picked-giphy-img" :src="pickedGiphy" @load="handleLoadingImages">
      <i class="fas fa-times-circle" @click.prevent="resetSelectedGif"></i>
    </div>
    <!-- REPLY -->
    <div class="reply-container" v-if="reply && reply.message">
      <span class="reply-user-name"><i class="fas fa-reply"></i> {{reply.name}}</span>
      <!-- REPLY TAGS GIPHY img -->
      <div class="reply-giphy-container" v-if="reply.tags && reply.tags.giphy">
        <img class="giphy-img" :src="reply.tags.giphy" @load="handleLoadingImages" v-if="reply.tags && reply.tags.giphy">
      </div>
      <span class="reply-text">{{reply.message}}</span>
      <i class="fas fa-times-circle reset-reply-btn" @click.prevent="resetReplyMessage"></i>
    </div>
    <!-- INPUTS -->
    <div class="chat-field-container">
      <span class="send-message-pinner" :class="{'isHighlightedMessage':isHighlightedMessage}" @click.prevent="isHighlightedMessage=!isHighlightedMessage" :style="isHighlightedMessage?{opacity:'1'}:{}" v-if="isAdmin"><i class="fas fa-thumbtack"></i></span>
      <div class="chat-field-header" title="Clique para trocar nome no chat">
        <i class="fas fa-user"></i>
        <!-- <label>{{$store.state.user.nickname || $store.state.user.name || $store.state.user.email || 'Anônimo'}}</label> -->
         <el-popover popper-class="chat-nickname-popover"
          placement="top"
          trigger="click"
          v-model="isUserNicknamePopupVisible"
          @show="userNickname = $store.state.user.nickname">
          <div style="display:flex; flex-direction:column;gap:2px">
            <p>Trocar nome no chat:</p>
            <el-input placeholder="Seu nome para o chat" size="small" clearable v-model="userNickname" @keypress.enter="changeUserNickname"></el-input>
            <el-button type="primary" size="small" style="margin:2px 0 0 auto" @click="changeUserNickname">OK</el-button>
          </div>
          <label style="display:inline-block; max-width:180px; white-space:nowrap; overflow:hidden; text-overflow: ellipsis;" slot="reference">{{$store.state.user.nickname || $store.state.user.name || $store.state.user.email || 'Anônimo'}}</label>
        </el-popover>
      </div>
      <div class="chat-field-wrapper">
        <textarea tabindex="0" ref="chatInput" class="chat-message-input" :class="{'isHighlightedMessage':isHighlightedMessage}" v-model="message" @keypress="checkSend" @focus="scrollOnScrollerClick" />
        <div class="emoji-picker-wrapper">
          <emoji-picker @emoji="append" :search="search">
            <div class="emoji-invoker" slot="emoji-invoker" slot-scope="{ events: { click: clickEvent } }" @click.stop="clickEvent">
              <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 0h24v24H0z" fill="none"/>
                <path  d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"/>
              </svg>
            </div>
            <div slot="emoji-picker" slot-scope="{ emojis, insert }">
              <div class="chat-emoji-picker">
                <div class="emoji-picker__search">
                  <input type="text" v-model="search" v-focus>
                </div>
                <div>
                  <div v-for="(emojiGroup, category) in emojis" :key="category">
                    <h5>{{ category }}</h5>
                    <div class="emojis">
                      <span v-for="(emoji, emojiName) in emojiGroup" :key="emojiName" @click="insert(emoji)" :title="emojiName">{{ emoji }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </emoji-picker>
        </div>
        <button class="gif-btn" @click="showGiphyPicker=!showGiphyPicker" v-if="enableGiphy">GIF</button>
        <button class="chat-send-button" @click="sendMessage" v-if="chat.enableSendButton">
          <ion-icon style="transform: rotate(45deg)" class="send-button-ionicon" name="paper-plane-outline"></ion-icon>
        </button>
      </div>
      <!-- <button @click.prevent="sendTESTChatMessages">sendTESTChatMessages</button> -->
    </div>
  </section>
</template>

<script>
import api from '@/services/api';
import graphqlAPI from '@/services/graphqlAPI';
import EmojiPicker from 'vue-emoji-picker';
import GiphyPicker from '@/components/general/GiphyPicker.vue';

import { createChatBlitzar } from '@/graphql/mutations';
import GraphQLSocket from '@/services/graphqlSocket.js';

const isURL = /(?:https?:\/\/)?(?:www\.)?(\w+\.)+\w+(?:\/\S*)?/;
const isEmail = /(\w+@[a-zA-Z_]+(\.[a-zA-Z]{2,6})+)/;

export default {
  name: 'Chatbox',
  components: { EmojiPicker, GiphyPicker },
  directives: {
    focus: {
      inserted(el) {
        el.focus();
      },
    },
  },
  props: {
    activityData: {
      type: Object,
      default: () => { }
    },
    showPinnedChatMessages: {
      type: Boolean,
      default: true
    },
    channel: {
      type: String,
      default: ''
    },
  },

  data() {
    return {
      isAdmin: false,
      userNickname: '',
      isUserNicknamePopupVisible: false,
      wsClientChat: null,
      emojiIconFill: 'white',
      message: '',
      input: '',
      search: '',
      isHighlightedMessage: false,
      showGiphyPicker: false,
      pickedGiphy: '',
      reply: null,
      readyToScroll: true,
      enableAutoScroll: true,
      loadedGifsCount: 0,
      messages: [],
      pinnedChatMessages: [],
      updateInterval: null,
    };
  },

  computed: {
    enableReply() {
      return this.activityData.property.enableChatReply;
    },
    enableGiphy() {
      return this.activityData.property.enableChatGiphy;
    },
    enableAvatar() {
      return this.activityData.property.enableChatUserAvatar;
    },
    enableLineBreak() {
      return this.activityData.property.enableChatLineBreak;
    },
    activeChannel() {
      return this.channel ? this.channel : this.$route.params.stream;
    },
  },

  methods: {
    isUser(user_id, userId) {
      return this.$store.state.user.id === user_id || this.$store.state.user.id === userId;
    },
    usesLinkButton(pinnedMsg) {
      return typeof pinnedMsg.link == 'string' && !pinnedMsg.link.startsWith('{"name":""');
    },
    openPinnedLink(link) {
      try {
        if (typeof link == 'string' && link.startsWith('http')) {
          window.open(link, '_blank');
        } else {
          const obj = JSON.parse(link);
          let routeData = this.$router.resolve(obj);
          window.open(routeData.href, '_blank');
        }
      } catch (err) {
        console.error(err);
      }
    },
    append(emoji) {
      this.message += emoji;
      this.$nextTick(() => {
        this.$refs.chatInput.scrollLeft = this.$refs.chatInput.scrollWidth;
      });
    },
    insert(emoji) {
      this.input += emoji;
    },
    handleLoadingImages() {
      const totalImages = this.$refs.messagesContainer.querySelectorAll('.giphy-img').length;
      this.loadedGifsCount++;
      if (this.enableAutoScroll) {
        if (totalImages === 0 || this.loadedGifsCount === 1 || this.loadedGifsCount === 2 || this.loadedGifsCount === totalImages) {
          this.scrollToMostRecentMessage();
          this.loadedGifsCount = 0;
        }
      }
    },
    scrollHandler(e) {
      // console.log('scrollHandler');
      if (!e || !this.$refs.messagesContainer) return
      const scrollTop = Math.ceil(this.$refs.messagesContainer.scrollTop);
      const scrollHeight = this.$refs.messagesContainer.scrollHeight;
      const clientHeight = this.$refs.messagesContainer.clientHeight;
      // console.log('scrollTop', scrollTop, scrollHeight - clientHeight);
      this.$nextTick(() => {
        if (scrollHeight - clientHeight <= scrollTop) {
          this.readyToScroll = true;
        }
        else {
          this.readyToScroll = false;
        }
      })
    },
    scrollToMostRecentMessage() {
      if (!this.$refs.messagesContainer || this.enableAutoScroll === false) return
      this.$refs.messagesContainer.scrollTop = this.$refs.messagesContainer.scrollHeight;
    },
    scrollOnScrollerClick() {
      if (!this.$refs.messagesContainer) return;
      this.$refs.messagesContainer.scrollTop = this.$refs.messagesContainer.scrollHeight;
      this.readyToScroll = true;
    },
    updatePosition() {
      this.$nextTick(() => {
        if (this.readyToScroll) this.scrollToMostRecentMessage();
      });
    },
    checkSend(event) {
      if (event.key == 'Enter' && !event.shiftKey && !event.ctrlKey && !event.altKey) {
        this.sendMessage();
        this.$refs.chatInput.blur();
      }
    },
    resetAll() {
      this.reply = null;
      this.showGiphyPicker = false;
      this.pickedGiphy = '';
      this.message = '';
    },
    replyChatMessage(msg) {
      this.reply = msg
      this.$refs.chatInput.focus();
      this.$nextTick(() => {
        this.scrollToMostRecentMessage();
      });
    },
    resetReplyMessage() {
      this.reply = null
    },
    deleteChatMessage(message) {
      // console.log('deleteChatMessage', { message });
      if (confirm('Remover mensagem?')) {
        let msg = {
          type: 'chat-delete',
          chat_id: message.chat_id,
          channel: this.activeChannel,
          isTrigger: false,
        };

        if (this.activityData.property.useGraphQL) {
          this.sendGraphqlChatBlitzar(msg);
        }
        else if (!this.activityData.property.disableChatWS) {
          this.wsClientChat.send(JSON.stringify(msg));
        }
        if (this.activityData.property.disableChatAPI) return;
        else {
          if (message.chat_id) {
            api
              .delete(`activity/${this.activeChannel}/chat/${message.chat_id}`)
              .catch(err => {
                console.error('error deleting chat', err);
              });
          } else {
          }
        }
      } else {
        // Do nothing!
      }
    },
    unpinChatMessage(message) {
      // console.log('unpinChatMessage', { message });
      if (confirm('Soltar mensagem?')) {
        api
          .delete(`activity/${this.activeChannel}/chatFixed/${message.chat_fixed_id}`)
          .then(response => {
            // console.log('unpinChatMessage response', { response });
            this.apiGetPinnedChatMessages();
          })
          .catch(err => {
            console.error('error saving chat', err);
          });
        let msg = {
          type: 'chat-delete',
          chat_id: message.chat_fixed_id,
          channel: this.activeChannel,
          isTrigger: true,
        };
        if (this.activityData.property.useGraphQL) {
          this.sendGraphqlChatBlitzar(msg);
        }
        else if (!this.activityData.property.disableChatWS) {
          this.wsClientChat.send(JSON.stringify(msg));
        }
      } else return;
    },
    pinChatMessage(message, pinned) {
      if (confirm('Fixar mensagem no topo?')) {
        let payload = {
          message: message.message,
          tags: null,
          highlight: pinned,
          link: null,
          fixed: true,
          name: message.nickname || message.name || message.email || 'Anônimo',
          image: message.image,
          timestamp: Date.now(),
        };
        if (pinned) {
          api
            .post(`activity/${this.activeChannel}/chatFixed`, payload)
            .then(response => {
              this.highlightChatMessage(message, pinned);
              this.apiGetPinnedChatMessages();
            })
            .catch(error => {
              console.error('put chatFixed error', error);
            });
        } else this.highlightChatMessage(message, false);
      }
    },
    highlightChatMessage(message, highlight = true) {
      let payload = { highlight: highlight };
      api
        .put(`activity/${this.activeChannel}/chat/${message.chat_id}`, payload)
        .then(response => {
          this.messages.map(msg => {
            if (message.chat_id == msg.chat_id) msg.highlight = highlight;
          });
          message.isTrigger = true;
          this.message = message;
          this.sendMessage();
        })
        .catch(error => {
          console.error('put chatHighlight error', error);
        });
    },
    visibleChatMessage(msg, visible) {
      const message = msg;
      // console.log('visibleChatMessage', pinned, message);
      let payload = {};
      let method = visible ? 'chatVisible' : 'chatUnvisible';
      api
        .post(`activity/${this.activeChannel}/${method}/${message.chat_id}`, payload)
        .then(response => {
          this.messages.map(msg => {
            if (message.chat_id == msg.chat_id) msg.visible = visible;
          });
          message.isTrigger = true;
          this.message = message;
          this.sendMessage();
        })
        .catch(error => {
          console.error('post chatVisible error', error);
        });
    },
    gifPicked(gif) {
      this.pickedGiphy = gif;
      this.$refs.chatInput.focus();
      this.showGiphyPicker = false;
    },
    resetSelectedGif() {
      this.pickedGiphy = '';
      this.$refs.giphyPicker.resetSelectedGif();
    },
    parseMsg(msg) {
      const { message, tags } = msg;
      if (!message) return;

      const isAdmin = tags && tags.isAdmin;

      if (isURL.test(message) && !isEmail.test(message)) {
        if (isAdmin) {
          return message.replace(isURL, (match) => {
            const href = match.startsWith('http') ? match : `https://${match}`;
            return `<a style="font-weight:bold;text-decoration:underline" href="${href}" target="_blank">${match}</a>`;
          });
        }
        else return message;
      } else if (isEmail.test(message)) {
        if (isAdmin) {
          return message.replace(isEmail, (match) => {
            return `<a style="font-weight:bold;text-decoration:underline" href="mailto:${match}" target="_blank">${match}</a>`;
          });
        }
        else return message;
      } else {
        return message;
      }
    },
    parsePinnedMsg(message) {
      if (!message) return;

      if (isURL.test(message) && !isEmail.test(message)) {
        return message.replace(isURL, (match) => {
          const href = match.startsWith('http') ? match : `https://${match}`;
          return `<a style="font-weight:bold;text-decoration:underline" href="${href}" target="_blank">${match}</a>`;
        });
      } else if (isEmail.test(message)) {
        return message.replace(isEmail, (match) => {
          return `<a style="font-weight:bold;text-decoration:underline" href="mailto:${match}" target="_blank">${match}</a>`;
        });
      } else {
        return message;
      }
    },
    apiGetChatMessages() {
      const chatText = this.isAdmin ? 'chat' : 'chat';//'chatVisible';
      let chatLimit = this.isMobile ? 36 : 200;
      api
        .get(`activity/${this.activeChannel}/${chatText}?limit=${chatLimit}&visibleGaranty=${this.activityData.property.chatModerate ? true : false}`)
        .then(response => {
          this.scrollHandler();
          this.messages = response.data.reverse();
          this.messages = this.messages.map(msg => {
            if (msg.tags && msg.tags.startsWith('{')) msg.tags = JSON.parse(msg.tags);
            return msg;

          });
          this.updatePosition();
        })
        .catch(err => {
          console.error('error getting chat', err);
        });
    },
    apiGetPinnedChatMessages() {
      api
        .get(`activity/${this.activeChannel}/chatFixed?limit=200`)
        .then(response => {
          if (response.data.length) {
            this.pinnedChatMessages = response.data.filter(msg => msg.fixed);
          }
        })
        .catch(err => {
          console.error('error getting chat', err);
        });
    },
    sendMessage() {
      if (!this.message && !this.pickedGiphy) return;
      if (this.message === '' && this.pickedGiphy) this.message = ' ';

      const message = this.message;
      const pinned = this.isHighlightedMessage;
      const tags = { isAdmin: this.isAdmin, reply: this.reply, giphy: this.pickedGiphy };
      // console.log('SEND CHAT MESSAGE: ', { message }, { tags });

      let msg = {
        type: 'chat-message',
        chat_id: this.$RNG.randomID(),
        userId: this.$store.state.user.id,
        name: this.$store.state.user.nickname || this.$store.state.user.name || this.$store.state.user.email || 'Anônimo',
        image: this.$store.state.user.picture,
        message: message,
        highlight: pinned,
        timestamp: Date.now(),
        channel: this.activeChannel,
        isTrigger: message.isTrigger,
        visible: message.isTrigger ? message.visible : !this.activityData.property.chatModerate,
        tags: tags ? JSON.stringify(tags) : null,
      };
      let obj = {
        chat_room_id: this.activeChannel,
        //message: '['+new Date(Date.now()).toLocaleString() +']: '+ message,
        message: message,
        tags: null,
        highlight: pinned,
        timestamp: msg.timestamp,
        name: msg.name,
        image: msg.image,
        visible: message.isTrigger ? message.visible : !this.activityData.property.chatModerate,
        tags: tags ? JSON.stringify(tags) : null,
      };

      if (this.activityData.property.disableChatAPI) return;
      else {
        if (message.isTrigger) {
          msg.chat_id = msg.message.chat_id;
          if (this.activityData.property.useGraphQL) {
            this.sendGraphqlChatBlitzar(msg);
          } else {
            if (this.activityData.property.disableChatWS) {
            } else {
              this.wsClientChat.send(JSON.stringify(msg));
            }
          }
        } else {
          api
            .post(`activity/${this.activeChannel}/chat`, obj)
            .then(response => {
              // console.log('SENT CHAT MESSAGE RESPONSE: ', { response });
              msg.chat_id = response.data.chat_id;
              if (this.activityData.property.useGraphQL) {
                this.sendGraphqlChatBlitzar(msg);
              }
              else if (!this.activityData.property.disableChatWS) {
                this.wsClientChat.send(JSON.stringify(msg));
              }
              if (pinned) this.pinChatMessage({ message: msg, pinned: true });
            })
            .catch(err => {
              console.error('error saving chat', err);
            });
        }
      }
      if (!msg.visible && !msg.isTrigger) {
        const moderation = this.activityData.property.moderationTextHide ? '' : '[Em moderação] ';
        let msgAlert = {
          type: 'chat-message',
          chat_id: this.$RNG.randomID(),
          userId: this.$store.state.user.id,
          name: this.$store.state.user.nickname || this.$store.state.user.name || this.$store.state.user.email || 'Anônimo',
          image: this.$store.state.user.picture,
          message: moderation + message,
          highlight: pinned,
          timestamp: Date.now(),
          channel: this.activeChannel,
          isTrigger: message.isTrigger,
          visible: message.isTrigger ? message.visible : !this.activityData.property.chatModerate,
          alert: true
        };
        this.scrollHandler();
        this.messages.push(msgAlert);
        this.$nextTick(_ => {
          this.updatePosition();
        });
      }

      this.resetAll();
    },
    receiveMessage(incoming) {
      let msg = JSON.parse(incoming.data);
      // console.log('receiveMessage', msg.type, { msg });

      if (msg.type == 'chat-message') {
        // console.log('CHAT receiveMessage', { msg });

        if (msg.tags && msg.tags.startsWith('{')) {
          msg.tags = JSON.parse(msg.tags);
        }

        if (msg.highlight) {
          this.pinnedChatMessages.push(msg);
          this.pinnedChatMessages.reverse();
        }

        let messagesLength = this.messages.length;
        if (this.isMobile) {
          if (messagesLength > 36) {
            this.messages.splice(0, messagesLength - 36);
          }
        } else {
          if (messagesLength > 300) {
            this.messages.splice(0, messagesLength - 300);
          }
        }

        if (msg.isTrigger) {
          this.messages.map(message => {
            if (message.chat_id == msg.chat_id) {
              this.scrollHandler();
              message.highlight = msg.message.highlight;
              message.visible = msg.message.visible;
            }
          });

          const modMessagesToBeRemoved = this.messages.filter(message => {
            return message && msg.message && msg.message.userId && message.userId === msg.message.userId && message.message === `[Em moderação] ${msg.message.message}`
          });

          if (modMessagesToBeRemoved.length) {
            this.messages.splice(this.messages.indexOf(modMessagesToBeRemoved[0]), 1);
          }

          this.apiGetPinnedChatMessages();

          this.$nextTick(_ => {
            this.updatePosition();
          });
        } else {
          try {
            const found = this.messages.find(message => message.chat_id == msg.chat_id);
            if (!found) {
              this.scrollHandler();
              this.messages.push(msg);
              // console.log('CHAT receiveMessage', { msg });
              this.$nextTick(_ => {
                this.updatePosition();
              });
            }
          } catch (error) { }
        }
      } else if (msg.type == 'chat-delete') {
        // console.log('DELETE CHAT receiveMessage', { msg }, msg.chat_id);
        if (msg.isTrigger) {
          this.pinnedChatMessages = this.pinnedChatMessages.filter(message => message.chat_fixed_id != msg.chat_id);
        } else {
          this.messages = this.messages.filter(message => message.chat_id != msg.chat_id);
        }
      }
      else {
        // console.log('CHAT receiveMessage', { msg });
      }
    },
    connectChat() {
      this.wsClientChat = new WebSocket('wss://chat.blitzar.com.br');
      this.wsClientChat.addEventListener('message', this.receiveMessage);
      this.wsClientChat.addEventListener('open', () => {
        this.wsClientChat.send(
          JSON.stringify({
            type: 'subscribe',
            channel: this.activeChannel,
          }),
        );
      });
      this.wsClientChat.addEventListener('close', () => {
        this.wsClientChat = null;
        setTimeout(this.connectChat, 300000);
      });
      this.wsClientChat.addEventListener('error', () => {
        this.wsClientChat.close();
      });
    },

    async subscribeGraphQl() {
      // console.log('GraphQL subscribe');
      this.wsClientChat = await GraphQLSocket.subscribeGraphQl(this.$store.state, this.activeChannel, null);
      // console.log('wsclient=', this.wsClientChat);
      this.wsClientChat.addEventListener('treating', this.treatEvent);
    },

    treatEvent(incoming) {
      // console.log('TreatEvent', incoming);
      if (incoming.detail) this.receiveMessage(incoming.detail);
      //this.wsClientChat.unsubscribe();
    },

    sendGraphqlChatBlitzar(msg) {
      // console.log('sendMessageWithGraphQl', msg);
      // this.wsClientChat.send(
      //   JSON.stringify(msg),
      // );
      const name = 'chat';
      const message = JSON.stringify(msg);
      const activity_id = this.activeChannel;//'314a2460-43bb-11eb-bda6-a37b5e22abbb';//this.$route.params.stream;
      const todo = { name, message, activity_id };
      graphqlAPI
        .post('', {
          query: createChatBlitzar,
          variables: { input: todo },
          //authToken: this.$store.state.user.tokenJWT,
        })
        .then(response => {
          // console.log('SENT CHAT MESSAGE RESPONSE: ', { response });
          // msg.chat_id = response.data.chat_id;
          // if (this.activityData.property.chatGraphQL) {
          //   this.sendGraphqlChatBlitzar(msg);
          // } else {
          //   if (this.activityData.property.disableChatWS) {
          //   } else {
          //     this.wsClientChat.send(JSON.stringify(msg));
          //   }
          // }
          // if (pinned) this.pinChatMessage({ message: msg, pinned: true });
        })
        .catch(err => {
          console.error('error saving chat', err);
        });;
    },

    changeUserNickname() {
      api
        .put(`event/${this.$store.state.eventId}/user/${this.$store.state.user.id}`, { nickname: this.userNickname }).then(response => {
          this.$store.commit('setUserNickname', this.userNickname);
          this.isUserNicknamePopupVisible = false;
        }).catch(err => {
          console.error('error changing user nickname', err);
        });
    },

    // subscribeGraphQl_AWS() {
    //   // console.log('GraphQL subscribe');
    //   this.subscriptionGraphQL = API.graphql({
    //     query: OnCreateChatBlitzarByActivityId,
    //     variables: {
    //       activity_id: this.$route.params.stream,
    //     },
    //     authToken: this.$store.state.user.tokenJWT,
    //   })
    //     .subscribe({
    //       next: (eventData) => {

    //         let msg = eventData.value.data.onCreateChatBlitzarByActivityId.message;
    //         //console.log('GraphqlMsg =',msg);
    //         try {
    //           const rec = JSON.parse(msg);
    //           //console.log('GraphqLMsgParse =',rec);
    //           if (rec.type === 'chat-message') {
    //             //console.log('ToReceive =',msg)
    //             this.receiveMessage({ data: msg });

    //           }
    //         } catch (err) {
    //           console.error(err);
    //         }
    //         return;
    //       }
    //     });
    // },

    // async createChatBlitzar(msg) {
    //   //console.log('Create TODO:', msg);
    //   const name = 'chat';
    //   const message = JSON.stringify(msg);
    //   const activity_id = this.$route.params.stream;
    //   const todo = { name, message, activity_id };
    //   await API.graphql({
    //     query: createChatBlitzar,
    //     variables: { input: todo },
    //     authToken: this.$store.state.user.tokenJWT,
    //   });
    // },

    // TEST METHOD - mass sender
    sendTESTChatMessages() {
      for (let i = 0; i < 80; i++) {
        setTimeout(() => {
          // this.sendMessage({ message: `Teste ${i}`, isTrigger: false, tags: { giphy: "https://media0.giphy.com/media/H9VVXzT1LqDS4jDVf5/giphy-preview.gif?cid=855caf8b57fb818283c9b51260f78cc99a2df80175486d5c&rid=giphy-preview.gif&ct=s" } });
        }, 1000 * i);
        this.message = { message: `Teste ${i}`, isTrigger: false, };
        this.sendMessage();
        // this.sendMessage({ message: `Teste ${i}`, isTrigger: false, tags: { giphy: "https://media0.giphy.com/media/H9VVXzT1LqDS4jDVf5/giphy-preview.gif?cid=855caf8b57fb818283c9b51260f78cc99a2df80175486d5c&rid=giphy-preview.gif&ct=s" } });

      }
    },
  },
  insert(emoji) {
    this.message += emoji;
  },
  beforeMount() {
    this.chat = this.$store.state.template.chat;
    this.emojiIconFill = this.chat.inputTextColor;
    this.isAdmin = this.$store.state.user.role === '1819bd5e-7b46-11ea-bc55-0242ac130003' || this.$store.state.user.role === '1819bea8-7b46-11ea-bc55-0242ac130003'; //operators and admins
    this.userNickname = this.$store.state.user.nickname;

    if (this.activityData.property.disableChatWS === true) {
      this.wsClientChat = null;
    }
    else {
      this.connectChat();
    }

    if (this.activityData.property.useGraphQL) {
      this.subscribeGraphQl();
    }

    this.apiGetChatMessages();
    this.apiGetPinnedChatMessages();
  },
  mounted() {
    this.$refs.scrollToTopBtn.addEventListener('click', this.scrollOnScrollerClick);
    if (!this.activityData.property.disableChatAPI) {
      this.updateInterval = setInterval(() => {
        this.apiGetChatMessages();
        this.apiGetPinnedChatMessages();
      }, 90000);
    }
  },
  beforeDestroy() {
    this.$refs.scrollToTopBtn.removeEventListener('click', this.scrollOnScrollerClick);
    clearInterval(this.updateInterval);


    if (this.activityData.property.useGraphQL) {
      try {
        GraphQLSocket.unsubscribe();
      } catch (error) { }
    }
    else if (this.wsClientChat) {
      try {
        if (this.wsClientChat) this.wsClientChat.send(
          JSON.stringify({
            type: 'unsubscribe',
            channel: this.currentWSChannel,
          }),
        );
        this.wsClientChat = null;
      } catch (error) { }
    }
  },
};
</script>

<style lang="scss">
.chatbox {
  position: relative;
  padding: 4px 13px 10px;
  height: 100%;
  width: 100%;
  // margin-left: 20px;
  background: var(--chat-mainColor) !important;
  border: 1px solid var(--chat-outlineColor) !important;
  border-radius: var(--chat-borderRadius);

  display: flex;
  flex-direction: column;
  @include media("<=tablet") {
    margin-left: 0;
    padding-left: 2%;
    padding-right: 2%;
  }
  @include media("<=phone") {
    margin: 0;
  }

  .chat-header-container {
    position: relative;
    height: auto;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
    color: var(--chat-headerColor);

    .header-icon-and-title {
      position: relative;
      width: 100%;
      opacity: 0;

      display: flex;
      align-items: center;
      justify-content: flex-start;
      .chat-icon {
        position: relative;
        color: var(--chat-headerColor);
        font-size: 1.8rem;
        margin-right: 8px;
      }
      .chat-title {
        position: relative;
        text-align: center;
        color: var(--chat-headerColor);
        // width: 100%;
        height: 48px;
        font-size: 1.2rem;
        letter-spacing: 1px;
        display: flex;
        align-items: center;
      }
    }
  }
  .chatbox-pinned-chat-message-container {
    position: relative;
    padding: 4px 0 6px 0;
    width: 100%;
    max-height: 100px;
    overflow-y: auto;
    z-index: 1;
    display: flex;
    flex-direction: row-reverse;
    flex-wrap: wrap;
    align-items: center;
    scroll-behavior: smooth;

    &::-webkit-scrollbar {
      background-color: transparent;
      width: 10px;
    }
    &::-webkit-scrollbar-track {
      background-color: var(--chat-scrollbarBGColor) !important;
    }
    &::-webkit-scrollbar-thumb {
      background-color: var(--chat-scrollbarHandleColor) !important;
    }

    .pinned-chat-message {
      position: relative;
      width: 100%;
      // min-height: 50px;
      background: var(--chat-pinnedBGColor);
      color: #000;
      border-radius: var(--chat-borderRadius);
      display: flex;
      padding: 2% 4% 2% 5%;
      margin-bottom: 4px;
      animation: pinned-chat-message-fadeIn 3s;

      &:hover > .pinned-chat-message-delete {
        opacity: 1;
      }

      img {
        position: relative;
        object-fit: cover;
        width: 40px;
        height: 40px;
        margin: 4px 8px 4px 0px;
        border-radius: 50%;
      }
      .pinned-chat-message-texts {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;

        @include media("<=tablet") {
          // padding: 2%;
        }
        .pinned-chat-message-user-name {
          position: relative;
          font-size: 1.1rem;
          font-weight: bold;
          color: var(--chat-pinnedNameColor);
          margin-bottom: 2px;
          // opacity: 0.9;
        }
        .pinned-chat-message-text {
          position: relative;
          // width: 100%;
          color: var(--chat-pinnedTextColor);
        }
      }
      .pinned-chat-message-btn {
        position: relative;
        width: 30px;
        height: 24px;
        margin-top: 20px;
        margin-left: auto;
        background: #ccc;
        border: none;
        border-radius: 50%;
        cursor: pointer;
        transition: all 0.1s ease-in-out;

        i {
          font-size: 0.9rem;
        }

        &:hover {
          transform: scale(1.1);
        }
        &:active {
          transform: scale(0.98);
        }
      }
    }
  }
  .pinned-chat-message-delete {
    position: absolute;
    top: 0px;
    right: 0px;
    color: var(--chat-editBtnColor);
    background: var(--chat-editBtnBGColor);
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: all 0.3s ease-in-out;
    i {
      font-size: 0.9rem;
    }
    &:hover {
      opacity: 1;
    }
  }
  @keyframes pinned-chat-message-fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  .pinned-chat-message-avatar-img {
    object-fit: cover;
    width: 36px;
    height: 36px;
    margin: 4px;
    margin-right: 10px;
    border-radius: 50%;
  }
  .chat-messages-container {
    position: relative;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: var(--chat-bgColor);
    border: 1px solid var(--chat-messagesOutlineColor);
    border-radius: var(--chat-borderRadius);
    padding: 2%;
    padding-top: 4%;
    padding-left: 0;
    scroll-behavior: smooth;

    &::-webkit-scrollbar {
      background-color: transparent;
      width: 10px;
    }
    &::-webkit-scrollbar-track {
      background-color: var(--chat-scrollbarBGColor) !important;
    }
    &::-webkit-scrollbar-thumb {
      background-color: var(--chat-scrollbarHandleColor) !important;
    }
  }
  .scrollToTopBtn {
    width: 34px;
    height: 34px;
    position: absolute;
    bottom: 80px;
    right: 46%;
    z-index: 1;
    outline: none;
    border: none;
    cursor: pointer;
    border-radius: 50%;
    display: block;
    color: var(--chat-scrollbarHandleColor);
    background: var(--chat-scrollbarBGColor);
  }
  .scrollBtn-icon {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    transform: scale(1.3);
    // font-size: 2.7rem;
  }
  .chat-message {
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 4px;
    // background-color: red;
    span:nth-child(2) {
      margin-left: 2px;
    }
  }
  .chat-message:hover > .chat-message-pinner {
    opacity: 1;
  }
  .chat-message-pinner {
    position: absolute;
    // top: 0;
    right: 4px;
    padding: 0 4px;
    opacity: 0;
    background: var(--chat-editBtnBGColor);
    color: var(--chat-editBtnColor);
    border-radius: 4px;
    z-index: 1;
    i {
      font-size: 0.98rem;
    }
  }
  .send-message-pinner {
    position: absolute;
    top: -15px;
    left: -15px;
    width: 30px;
    height: 30px;
    z-index: 1;
    padding: 3px;
    background: #666;
    border-radius: 40px;
    box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.4);
    opacity: 0;
    transition: all 0.4s ease-in-out;

    display: flex;
    align-items: center;
    justify-content: center;
    i {
      font-size: 0.92rem;
    }
    &:hover {
      opacity: 1;
    }
  }
  .chat-message-input:focus + .send-message-pinner {
    opacity: 1;
  }
  .chat-message-content {
    position: relative;
    width: auto;
    padding: 6px 8px;
    // margin-top: 4px;
    margin-right: 2px;
    margin-left: 8px;
    font-size: 0.9rem;

    color: var(--chat-textColor);
    background-color: var(--chat-boxColor);
    border-radius: var(--chat-borderRadius);
    // opacity: 0.9;

    display: flex;
    // flex-wrap: wrap;
    flex-direction: column;
    // align-items: flex-start;
    // align-content: flex-start;
    // justify-content: flex-start;
    // gap: 4px;

    .avatar-and-name-container {
      position: relative;
      width: 100%;

      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 4px;

      .chat-user-avatar {
        align-self: flex-start;
        position: relative;
        // flex-shrink: 0;
        // flex-grow: 0;
        height: 30px;
        width: 30px;
        border-radius: 50%;
        object-fit: cover;
      }

      .chat-user-name {
        position: relative;
        width: auto;
        max-width: 100%;
        font-size: 0.9rem;
        font-weight: bold;
        color: var(--chat-nameColor);
        padding: 0px 5px;
        background-color: var(--chat-nameBoxColor);
        opacity: 0.9;
        border-radius: 4px;
        @include media("<=phone") {
          max-width: 160px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
      .chat-user-name-isAdmin {
        font-weight: bolder;
        color: var(--chat-adminNameColor);
        background-color: var(--chat-adminBoxColor);
      }
    }

    .message-giphy-container {
      position: relative;
      // width: 100%;
    }

    .message-text-container {
      position: relative;
    }
    .msg-message {
      // width: 100%;
      // white-space: pre-wrap;
      font-size: 1rem;
      word-break: break-word;
    }
    .with-line-brake {
      width: 100%;
      white-space: pre-line;
    }
  }
  .giphy-img {
    position: relative;
    padding: 4px 0 0;
    width: 100%;
    height: auto;
    max-width: 100px;
    object-fit: contain;
    border-radius: var(--chat-borderRadius);
  }
  .isHighlighted {
    background: var(--chat-pinnedBGColor);
    color: var(--chat-pinnedTextColor);
    // width: 100%;
    padding: 3%;
    font-size: 1.1rem;
  }
  .isHighlightedMessage {
    background: var(--chat-pinnedBGColor);
    background-color: var(--chat-pinnedBGColor) !important;
  }
  .reply-container {
    position: relative;
    margin: 8px 0;
    padding: 6px 10px;
    width: 100%;
    font-size: 0.9rem;
    color: var(--chat-textColor);
    background-color: var(--chat-boxColor);
    border-radius: var(--chat-borderRadius);
    opacity: 0.8;

    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    gap: 4px;

    .reply-user-name {
      font-weight: bold;
      i {
        font-size: 0.8rem;
        margin-left: 4px;
      }
    }
    .reply-text {
      word-break: break-word;
      font-style: italic;
    }
    .reset-reply-btn {
      position: absolute;
      top: 4px;
      right: 0;
      padding: 0 4px;
      background: var(--chat-editBtnBGColor);
      color: var(--chat-editBtnColor);
      border-radius: 4px;
      z-index: 1;
    }
  }
  .picked-giphy-container {
    position: relative;
    margin-top: 10px;
    padding: 0 10px;
    width: 100%;
    max-width: 100px;
    height: 100%;
    max-height: 100px;
    z-index: 1;
    background-color: var(--chat-boxColor);
    border-radius: var(--chat-borderRadius);

    display: flex;
    justify-content: center;
    align-items: center;
    .picked-giphy-img {
      position: relative;
      width: 100%;
      height: 100%;
      object-fit: contain;
      border-radius: var(--chat-borderRadius);
    }
    i {
      position: absolute;
      top: 4px;
      right: 0;
      padding: 0 4px;
      background: var(--chat-editBtnBGColor);
      color: var(--chat-editBtnColor);
      border-radius: 4px;
      z-index: 1;
    }
  }
  .chat-field-container {
    position: relative;
    width: 100%;
    height: 60px;
    background-color: transparent;
    margin-top: 8px;

    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;

    .chat-field-header {
      position: relative;
      width: 100%;
      // height: 10px;
      font-size: 0.7rem;
      // margin-bottom: 4px;
      opacity: 0.7;

      display: flex;
      align-items: center;

      label {
        position: relative;
        margin-top: 2px;
        color: var(--chat-headerColor);
        cursor: pointer;
      }

      i {
        font-size: 0.6rem;
        margin-right: 4px;
        color: var(--chat-headerColor);
      }
    }
  }
  .chat-field-wrapper {
    position: relative;
    width: 100%;

    display: flex;
    align-items: center;
  }
  .chat-message-input {
    position: relative;
    padding: 10px 8px 4px;
    flex-grow: 1;
    height: 42px;
    border: none;
    background-color: transparent;
    border-radius: var(--chat-borderRadius);
    outline: none;
    color: var(--chat-inputTextColor);
    background-color: var(--chat-inputBGColor);
    border: 1px solid var(--chat-inputOutlineColor);
    border-radius: var(--chat-borderRadius);
    resize: none;

    &:focus {
      outline: none;
    }
  }

  .chat-send-button {
    cursor: pointer;
    position: relative;
    flex-grow: 0;
    border: none;
    outline: none;
    width: 42px;
    height: 42px;
    background-color: var(--chat-sendBGColor);
    border: 1px solid var(--chat-sendOutlineColor);
    border-radius: var(--chat-borderRadius);
    color: var(--chat-inputTextColor);
    margin: 0 2px 0 4px;
  }
  .send-button-ionicon {
    color: var(--chat-sendTextColor);
    opacity: 0.5;
    font-size: 1.68rem;
    margin-top: 4px;
    margin-right: 5px;
    &:hover {
      opacity: 0.8;
    }
  }

  // EMOJI PICKER
  .emoji-picker-wrapper {
    // position: absolute;
    // bottom: 37px;
    // width: 100%;
    position: relative;
    // display: inline-block;
    z-index: 1;
  }
  .emoji-invoker {
    position: relative;
    // top: 0.5rem;
    // right: 60px;
    margin-left: 6px;
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    transition: all 0.2s;
    z-index: 1;
    opacity: 0.5;
    cursor: pointer;
    transform: scale(1.1);
    &:hover {
      opacity: 0.9;
    }
  }
  .chat-emoji-picker {
    position: absolute;
    top: -336px;
    left: -200px;
    padding: 1rem;
    padding-right: 8px;
    width: auto;
    height: 320px;
    overflow: auto;
    overflow-x: hidden;
    z-index: 1;
    border: 1px solid #ffffff80;
    box-sizing: border-box;
    border-radius: var(--chat-borderRadius);
    // background: var(--chat-bgColor);
    background: #555;
    &::-webkit-scrollbar {
      background-color: transparent;
      width: 10px;
    }
    &::-webkit-scrollbar-track {
      background-color: var(--chat-scrollbarBGColor);
    }
    &::-webkit-scrollbar-thumb {
      background-color: var(--chat-scrollbarHandleColor);
    }
  }
  .chat-emoji-picker h5 {
    margin: 0;
    margin-top: 10px;
    color: #ccc;
    // color: black;
    text-transform: uppercase;
    font-size: 1rem;
    cursor: default;
  }
  .regular-input {
    padding: 0.5rem 1rem;
    border-radius: 3px;
    border: 1px solid #ccc;
    width: 20rem;
    height: 12rem;
    outline: none;
  }
  .regular-input:focus {
    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
  }
  .emoji-invoker:hover {
    transform: scale(1.1);
  }
  .emoji-invoker > svg {
    fill: #fff;
    // opacity: 0.7;
  }
  .emoji-picker__search {
    position: relative;
    display: flex;
    height: 24px;
  }
  .emoji-picker__search > input {
    flex: 1;
    border-radius: 12px;
    border: 1px solid #ccc;
    padding: 0.5rem 1rem;
    outline: none;
    width: 90%;
  }
  .emoji-picker .emojis {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .emoji-picker .emojis:after {
    content: "";
    flex: auto;
  }
  .emoji-picker .emojis span {
    padding: 0.2rem;
    cursor: pointer;
    border-radius: 5px;
  }
  .emoji-picker .emojis span:hover {
    background: #ececec;
    cursor: pointer;
  }
  .emojis {
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    span {
      padding: 4px;
      cursor: pointer;
    }
  }
  .gif-btn {
    position: relative;
    margin-left: 6px;
    margin-right: 4px;
    width: 1.4rem;
    min-width: 1.4rem;
    height: 1.4rem;
    border-radius: 50%;
    border: 2px dashed #fff;
    outline: none;
    background: transparent;
    color: #fff;
    font-size: 0.6rem;
    font-weight: bolder;
    cursor: pointer;
    transition: all 0.2s;
    z-index: 1;
    opacity: 0.5;

    &:hover {
      opacity: 0.9;
    }
  }
}
// on hover make the chat-actions visible
.chat-message:hover > .avatar-and-name-container .chat-message-actions {
  opacity: 1;
}

// chat-message:hover makes the chat-actions visible
.avatar-and-name-container:hover > .chat-message-actions {
  opacity: 1;
}

.toggle-autoscroll-btn {
  position: absolute;
  bottom: 56px;
  right: 8px;
  background: red;
  outline: none;
  background: transparent;
  color: var(--chat-textColor);
  font-size: 0.7rem;
  transition: all 0.2s;
  z-index: 1;
  opacity: 0.4;

  &:hover {
    opacity: 1;
  }

  input {
    margin-left: 4px;
    cursor: pointer !important;
  }
}

.app__messenger {
  border-radius: var(--chat-borderRadius) !important;
  border: none !important;
}

.chat-nickname-popover {
  font-family: "Roboto", sans-serif;
  z-index: 1000000 !important;
}
</style>